import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../MyPage.js";
import SubTabsDashboard from "../../SubTabsDashboard.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class SupplierPurchasePlan extends Component{ 

    constructor(props){
      super(props);

      this.state={
          purchaseplan:[],
          modalTitle:"",
          fyname: "",
          regionname: "",
          countryname: "",
          warehousename: "",
          purchasetypename: "",
          itempurchased: "",
          itempurchasedid: "",
          itemdescription: "",
          poalert: "",
          povalidated: true,
          numbers: "",
		      total_value: "",
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",

          CountryNameFilter:"",
          WarehouseNameFilter:"",
          RegionNameFilter:"",
          FiscalYearFilter:"",
          ProductDescriptionFilter:"",
          PurchasePlanIdFilter:"",
          ItempurchasedFilter:"",
          ItempurchasedIdFilter:"",
          ItemDescriptionFilter:"",
          PurchasetypeNameFilter:"",
          CurrentYearFilter:"",
          purchaseplanWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [],
          items: [], 
          productdescriptions: [],
          containerdescriptions: [],
          purchasetypeNames: [],
          warehouseNames: [],
          loading: true,
          currentYearIndex: 0,
          currentYear: null,

          tf_purchaseplan:[],
          tf_purchasesplanid:0 ,
		tf_fyname: "",
		from_warehousename: "",
		to_warehousename: "",
		tf_itemtypename: "",
		tf_productid: 0,
		tf_sapcode: "",
		tf_productdescription: "",
		tf_numbers: "",
		tf_total_value: "",
		tf_july: "",
		tf_august: "",
		tf_september: "",
		tf_october: "",
		tf_november: "",
		tf_december: "",
		tf_january: "",
		tf_february: "",
		tf_march: "",
		tf_april: "",
		tf_may: "",
		tf_june: "",

    FromWarehouseNameFilter:"",
    ToWarehouseNameFilter:"",
          TfFiscalYearFilter:"",
          TfProductDescriptionFilter:"",
          TfPurchasePlanIdFilter:"",
          TfItemtypeNameFilter:"",
          TfSapCodeFilter:"",
          tf_purchaseplanWithoutFilter:[],

      }
  }

  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var PurchasePlanIdFilter = this.state.PurchasePlanIdFilter;
    var ItempurchasedFilter = this.state.ItempurchasedFilter;
    var ItempurchasedIdFilter = this.state.ItempurchasedIdFilter;
    var ItemDescriptionFilter = this.state.ItemDescriptionFilter;
    var PurchasetypeNameFilter = this.state.PurchasetypeNameFilter;
    var CurrentYearFilter = this.state.CurrentYearFilter;

    var filteredData=this.state.purchaseplanWithoutFilter.filter(
        function(el){
            return el.countryname.toString().toLowerCase().includes(
              CountryNameFilter.toString().trim().toLowerCase()
          )&&
          el.regionname.toString().toLowerCase().includes(
              RegionNameFilter.toString().trim().toLowerCase()
          )&&
             el.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.purchaseplanid.toString().toLowerCase().includes(
                PurchasePlanIdFilter.toString().trim().toLowerCase()
            )&&  
            el.itempurchased.toString().toLowerCase().includes(
              ItempurchasedFilter.toString().trim().toLowerCase()
        )&&  
        el.itempurchasedid.toString().toLowerCase().includes(
          ItempurchasedIdFilter.toString().trim().toLowerCase()
    )&&  
        el.purchasetypename.toString().toLowerCase().includes(
          PurchasetypeNameFilter.toString().trim().toLowerCase()
    )&&  
    el.itemdescription.toString().toLowerCase().includes(
      ItemDescriptionFilter.toString().trim().toLowerCase()
)
        }
    );

    this.setState({purchaseplan:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.purchaseplanWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({purchaseplan:sortedData});

}




FilterFnTf(){
  var FromWarehouseNameFilter = this.state.FromWarehouseNameFilter;
  var ToWarehouseNameFilter = this.state.ToWarehouseNameFilter;
  var TfFiscalYearFilter = this.state.TfFiscalYearFilter;
  var TfProductDescriptionFilter = this.state.TfProductDescriptionFilter;
  var TfPurchasePlanIdFilter = this.state.TfPurchasePlanIdFilter;
  var TfItemtypeNameFilter = this.state.TfItemtypeNameFilter;
  var TfSapCodeFilter = this.state.TfSapCodeFilter;

  var filteredData=this.state.tf_purchaseplanWithoutFilter.filter(
      function(el){
          return el.from_warehousename.toString().toLowerCase().includes(
              FromWarehouseNameFilter.toString().trim().toLowerCase()
          )&& el.to_warehousename.toString().toLowerCase().includes(
            ToWarehouseNameFilter.toString().trim().toLowerCase()
        )&&  
              el.tf_fyname.toString().toLowerCase().includes(
              TfFiscalYearFilter.toString().trim().toLowerCase()
          )&&  
              el.tf_purchasesplanid.toString().toLowerCase().includes(
              TfPurchasePlanIdFilter.toString().trim().toLowerCase()
          )&&  
          el.tf_productdescription.toString().toLowerCase().includes(
            TfProductDescriptionFilter.toString().trim().toLowerCase()
      )&&    
      el.tf_itemtypename.toString().toLowerCase().includes(
        TfItemtypeNameFilter.toString().trim().toLowerCase()
  )&&  
  el.tf_sapcode.toString().toLowerCase().includes(
    TfSapCodeFilter.toString().trim().toLowerCase()
)
      }
  );

  this.setState({tf_purchaseplan:filteredData});

}

sortResultTf(prop,asc){
var sortedData=this.state.tf_purchaseplanWithoutFilter.sort(function(a,b){
    if(asc){
        return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
    }
    else{
        return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
    }
});

this.setState({tf_purchaseplan:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

  changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


  changeItempurchasedFilter = (e)=>{
    this.state.ItempurchasedFilter=e.target.value;
    this.FilterFn();
  }

  changeItempurchasedIdFilter = (e)=>{
    this.state.ItempurchasedIdFilter=e.target.value;
    this.FilterFn();
  }


  changeItemDescriptionFilter = (e)=>{
    this.state.ItemDescriptionFilter=e.target.value;
    this.FilterFn();
  }

  changePurchaseTypeNameFilter = (e)=>{
    this.state.PurchasetypeNameFilter=e.target.value;
    this.FilterFn();
  }


changePurchasePlanIdFilter = (e)=>{
    this.state.PurchasePlanIdFilter=e.target.value;
    this.FilterFn();
  }

  changeCurrentYearFilter = (e)=>{
    this.state.CurrentYearFilter=e.target.value;
    this.FilterFn();
  }



  changeFromWarehouseNameFilter = (e)=>{
    this.state.FromWarehouseNameFilter=e.target.value;
    this.FilterFnTf();
  }


  changeToWarehouseNameFilter = (e)=>{
    this.state.ToWarehouseNameFilter=e.target.value;
    this.FilterFnTf();
  }


  changeTfFiscalYearFilter = (e)=>{
    this.state.TfFiscalYearFilter=e.target.value;
    this.FilterFnTf();
  }


  
changeTfPurchasePlanIdFilter = (e)=>{
  this.state.TfPurchasePlanIdFilter=e.target.value;
  this.FilterFnTf();
}

changeTfProductDescriptionFilter = (e)=>{
  this.state.TfProductDescriptionFilter=e.target.value;
  this.FilterFnTf();
}


changeTfItemtypeNameFilter = (e)=>{
  this.state.TfItemtypeNameFilter=e.target.value;
  this.FilterFnTf();
}

changeTfSapCodeFilter = (e)=>{
  this.state.TfSapCodeFilter=e.target.value;
  this.FilterFnTf();
}

refreshList = () => {
    axiosService.get('/purchaseplan/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ purchaseplan: data, purchaseplanWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  refreshListTf = () => {
    axiosService.get('/transferts_purchaseplan/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ tf_purchaseplan: data, tf_purchaseplanWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };



componentDidMount(){
  this.refreshList();
  this.refreshListTf();
}


render(){
  const {
      purchaseplan,
      modalTitle,
      purchaseplanid,
      fyname,
      regionname,
      countryname,
      warehousename,
      purchasetypename,
      itempurchased,
      itempurchasedid,
      itemdescription,
      numbers,
      total_value,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      fiscalYears,
      currentYearIndex,
      currentYear,


      tf_purchaseplan,
      tf_purchasesplanid,
      tf_fyname,
      Fromwarehousename,
      Towarehousename,
      tf_itemtypename,
		tf_productid,
		tf_sapcode,
		tf_productdescription,
      tf_numbers,
      tf_total_value,
      tf_july,
      tf_august,
      tf_september,
      tf_october,
      tf_november,
      tf_december,
      tf_january,
      tf_february,
      tf_march,
      tf_april,
      tf_may,
      tf_june,

  }=this.state;

  //const currentYear = fiscalYears[currentYearIndex];

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsDashboard />
<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Supplier PurchasesPlan
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Region
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCountryNameFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changePurchaseTypeNameFilter}
      placeholder="Filter"/>

      </div>
      PurchaseType
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItempurchasedFilter}
      placeholder="Filter"/>
      </div>
      Itempurchased
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItempurchasedIdFilter}
      placeholder="Filter"/>
      </div>
      ContainerID / SAP Code
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeItemDescriptionFilter}
      placeholder="Filter"/>
      </div>
      ItemDescription
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Numbers
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Value
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr (Value)
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun (Value)
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {purchaseplan.map(dep=>
      <tr key={dep.purchaseplanid} className="row-hover">
          <td className="table-text">{dep.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.regionname ?? 'N/A'}</td>
          <td className="table-text">{dep.countryname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.purchasetypename ?? 'N/A'}</td>
          <td className="table-text">{dep.itempurchased ?? 'N/A'}</td>
          <td className="table-text">{dep.itempurchasedid ?? 'N/A'}</td>
          <td className="table-text">{dep.itemdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.numbers ?? 'N/A'}</td>
          <td className="table-text">{dep.total_value ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.total_value) : 'N/A'}</td>
<td className="table-text">{dep.july ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.july) : 'N/A'}</td>
<td className="table-text">{dep.august ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.august) : 'N/A'}</td>
<td className="table-text">{dep.september ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.september) : 'N/A'}</td>
<td className="table-text">{dep.october ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.october) : 'N/A'}</td>
<td className="table-text">{dep.november ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.november) : 'N/A'}</td>
<td className="table-text">{dep.december ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.december) : 'N/A'}</td>
<td className="table-text">{dep.january ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.january) : 'N/A'}</td>
<td className="table-text">{dep.february ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.february) : 'N/A'}</td>
<td className="table-text">{dep.march ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.march) : 'N/A'}</td>
<td className="table-text">{dep.april ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.april) : 'N/A'}</td>
<td className="table-text">{dep.may ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.may) : 'N/A'}</td>
<td className="table-text">{dep.june ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.june) : 'N/A'}</td>

          <td>


          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div style={{ textAlign: 'left', fontWeight: 'bold',padding:"10px", fontSize: "14px" }}>
      Transferts PurchasesPlan
    </div>
<div className="table-container">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTfFiscalYearFilter}
      value={currentYear}
      placeholder="Filter"/>

      </div>
      Fiscal Year
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFromWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      FromWarehouse
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeToWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      ToWarehouse
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTfItemtypeNameFilter}
      placeholder="Filter"/>

      </div>
      ItemTypeName
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTfSapCodeFilter}
      placeholder="Filter"/>
      </div>
      SAP Code
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTfProductDescriptionFilter}
      placeholder="Filter"/>
      </div>
      ProductDescription
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Numbers
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Total Value
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr (Value)
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May (Value)
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun (Value)
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {tf_purchaseplan.map(dep=>
      <tr key={dep.tf_purchasesplanid} className="row-hover">
          <td className="table-text">{dep.tf_fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.from_warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.to_warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.tf_itemtypename ?? 'N/A'}</td>
          <td className="table-text">{dep.tf_sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.tf_productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.tf_numbers ?? 'N/A'}</td>
          <td className="table-text">{dep.tf_total_value ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_total_value) : 'N/A'}</td>
<td className="table-text">{dep.tf_july ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_july) : 'N/A'}</td>
<td className="table-text">{dep.tf_august ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_august) : 'N/A'}</td>
<td className="table-text">{dep.tf_september ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_september) : 'N/A'}</td>
<td className="table-text">{dep.tf_october ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_october) : 'N/A'}</td>
<td className="table-text">{dep.tf_november ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_november) : 'N/A'}</td>
<td className="table-text">{dep.tf_december ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_december) : 'N/A'}</td>
<td className="table-text">{dep.tf_january ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_january) : 'N/A'}</td>
<td className="table-text">{dep.tf_february ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_february) : 'N/A'}</td>
<td className="table-text">{dep.tf_march ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_march) : 'N/A'}</td>
<td className="table-text">{dep.tf_april ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_april) : 'N/A'}</td>
<td className="table-text">{dep.tf_may ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_may) : 'N/A'}</td>
<td className="table-text">{dep.tf_june ? Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(dep.tf_june) : 'N/A'}</td>

          <td>


          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text">Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text">Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Purchase Type</span>
          <select
            className="form-select"
            value={this.state.purchasetypename}
            
            onChange={(event) => this.setState({ purchasetypename: event.target.value })}
          >
            <option value="">Select a purchasetype</option>
            {this.state.purchasetypeNames.map((purchasetype) => (
              <option key={purchasetype} value={purchasetype}>
                {purchasetype}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Product</span>
          <select
            className="form-select"
            value={this.state.itempurchased}
            onChange={(event) => this.setState({ itempurchased: event.target.value })}
          >
            <option value="">Select a product</option>
            {this.state.containerdescriptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text">Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text">Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}/>

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text">Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text">May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}/>

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text">Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}/>

        </div>

        {purchaseplanid === 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {purchaseplanid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.updateClick(purchaseplanid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




